// Known roles today — extend when the backend exposes a roles list endpoint.
export type AdminRole = {
  id: number;
  label: string;
};

export const SUPER_ADMIN_ROLE_ID = 4;
export const ADMIN_ROLE_ID = 5;
export const MANAGER_ROLE_ID = 6;

export const ADMIN_ROLES: AdminRole[] = [
  { id: SUPER_ADMIN_ROLE_ID, label: "Super Admin" },
  { id: ADMIN_ROLE_ID, label: "Admin" },
  { id: MANAGER_ROLE_ID, label: "Manager" },
];

export const ADMIN_ROLE_LABELS: Record<number, string> = ADMIN_ROLES.reduce(
  (labels, role) => ({ ...labels, [role.id]: role.label }),
  {} as Record<number, string>,
);

// Roles selectable from the Create/Edit User form — Super Admin is excluded
// (it's a platform-level role, not something assignable from this UI).
export const ASSIGNABLE_ADMIN_ROLES: AdminRole[] = ADMIN_ROLES.filter(
  (role) => role.id !== SUPER_ADMIN_ROLE_ID,
);

export type AdminUser = {
  id: number;
  first_name: string;
  last_name: string;
  name: string;
  email: string;
  user_type?: string;
  role_id: number;
  client_id: number | null;
  active: boolean;
  created_by_user_id?: number | null;
  program_ids?: number[];
};

export type AdminClient = {
  id: number;
  code: string;
  name: string;
  type: string;
  is_active: boolean;
};

export type AdminProgram = {
  id: number;
  client_id: number;
  code: string;
  name: string;
  product_sk?: number;
  is_active: boolean;
};

export type CreateAdminUserPayload = {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  role_id: number;
  program_ids: number[];
};

export type UpdateAdminUserProfilePayload = {
  first_name?: string;
  last_name?: string;
  email?: string;
};
